export class UserDevice{
	id:number = 0;
	companyId:number = 0;
	deviceId:string = "";
	name:string = "Nieuw toestel";

	public constructor(data?:any){
		if (!data)return;
		this.id = data.ID;
		this.companyId = data.CompanyID;
		this.deviceId = data.DeviceID;
		this.name = data.Name;
	}

	public getJSON(){
		return {
			ID: this.id,
			CompanyID: this.companyId,
			DeviceID: this.deviceId,
			Name: this.name
		};
	}

	public getDisplayedText():string{
		let deviceIdText = this.deviceId;
		if (!deviceIdText){
			deviceIdText = "Nog niet gespecifierd";
		}
		return `${this.name} (${deviceIdText})`;
	}
}